import type { GravityFormsAPIFieldProps } from '@typings'

export const gfGetAccordionFields = (fields: GravityFormsAPIFieldProps[]) => {
  /* gfGetAccordionFields usage
  components wrapped around two gravityforms SECTIONS with as a label section-start-${component} and
  section-end will be wrapped in this component
  */

  const group = []
  let row = null
  let component = null
  let parent = null
  fields.forEach(field => {
    const { type, label } = field

    if (type === 'section' && label?.startsWith('section-start')) {
      row = []
      component = label.replace('section-start-', '')
      parent = field
      return
    }

    if (type === 'section' && label?.startsWith('section-end')) {
      group.push({
        ...parent,
        component,
        custom: true,
        items: row,
        errorMessages: row.reduce((cul, cur) => {
          return cul.concat(cur['error-messages'])
        }, []),
      })
      row = null
      component = null
      return
    }
    row ? row.push(field) : group.push(field)
  })
  return group
}
